import React from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsOverview = ({ sessions }) => {
  const totalSessions = sessions?.length || 0;
  const totalPhotos = sessions?.reduce((sum, session) => sum + session?.photoCount, 0) || 0;
  const overallAverage = totalSessions > 0
    ? (sessions?.reduce((sum, session) => sum + session?.averageScore, 0) / totalSessions)
    : 0;
  const highestEver = totalSessions > 0
    ? Math.max(...sessions?.map(s => s?.highestScore))
    : 0;

  const getScoreColor = (score) => {
    if (score >= 8) return '#10B981';
    if (score >= 6) return '#9333EA';
    if (score >= 4) return '#F59E0B';
    return '#EF4444';
  };

  const stats = [
    {
      label: 'Total Sessions',
      value: totalSessions,
      icon: 'History',
      color: '#9333EA',
      bgColor: 'bg-purple-100'
    },
    {
      label: 'Photos Analyzed',
      value: totalPhotos,
      icon: 'Image',
      color: '#06B6D4',
      bgColor: 'bg-cyan-100'
    },
    {
      label: 'Average Score',
      value: overallAverage?.toFixed(1),
      icon: 'BarChart3',
      color: getScoreColor(overallAverage),
      bgColor: 'bg-amber-100'
    },
    {
      label: 'Highest Score',
      value: highestEver?.toFixed(1),
      icon: 'Trophy',
      color: '#10B981',
      bgColor: 'bg-emerald-100'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-6 md:mb-8">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-xl border border-border p-4 md:p-5 transition-smooth hover:shadow-warm"
        >
          <div className="flex items-start justify-between mb-3">
            <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} color={stat?.color} />
            </div>
          </div>
          <div className="text-2xl md:text-3xl font-bold text-foreground mb-1 data-text">
            {stat?.value}
          </div>
          <div className="text-xs md:text-sm text-muted-foreground caption">
            {stat?.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatisticsOverview;